export default __webpack_public_path__ + "locales/ja-JP/FormFillingTipsDialog.json?hash=793c0ca194651a0daa825a0e089914a3";